jQuery(document).ready(function ($) {
    console.log('__akfunctions.js v2.7.2 ->');
    /*eslint-disable */
    function getbh() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    }
    ;
    function getbb() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
    ;
    function getspt() {
        return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
    }
    function getspb() {
        return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0) + getbh();
    }
    /*eslint-enable */
    var spt = getspt();
    $(window).scroll(function (event) {
        spt = getspt() > 0 ? getspt() : 0;
    });
    // //SCROLL IN VIEW <- make it a function
    // function scrollinview($el, treshold, distance){
    //   var treshold = typeof treshold !== 'undefined' ? treshold : 150;
    //   var distance = typeof distance !== 'undefined' ? distance : treshold;
    //   var position = $el.offset().top
    //   console.log('scrollinview() -> $el.position: '+ position +' spb: '+ getspb() +' [-'+treshold+']' );
    //   if (getspb() < position + treshold){ console.log('scrollinview() -> scrolling '+distance)
    //     $('html, body').animate({scrollTop: (position + distance - getbh()) + 'px'}, 250)
    //   }
    // }
    //AKBILDSCHIRM
    var bb, bh;
    var refreshcount = 0;
    $.fn.akbildschirm = function (init) {
        console.log('fn.akbildschirm() ->');
        bb = getbb();
        bh = getbh();
        console.log('bb: ' + bb + ' bh: ' + bh);
        this.each(function (index) {
            $this = $(this);
            var ratio = bb / bh > 1 ? 'landscape' : 'portrait';
            var shape = bb / bh >= 0.75 && bb / bh <= 1.5 ? 'square' : 'panorama';
            /*eslint-disable */
            var is_mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4));
            var is_HD = window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches) || window.devicePixelRatio && window.devicePixelRatio > 1.3;
            var is_Retina = (window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches) || window.devicePixelRatio && window.devicePixelRatio > 2) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
            /*eslint-enable */
            var is_iPhone = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i);
            var is_iPad = navigator.userAgent.match(/iPad/i);
            var is_iPhone6p = (bb == 414 && bh >= 628 && ratio == 'portrait' || bb == 736 && bh >= 306 && ratio == 'landscape') && is_iPhone;
            var is_iPhone6 = (bb == 375 && bh >= 559 && ratio == 'portrait' || bb == 667 && bh >= 267 && ratio == 'landscape') && is_iPhone;
            var is_iPhone5 = (bb == 320 && bh >= 460 && ratio == 'portrait' || bb == 568 && bh >= 212 && ratio == 'landscape') && is_iPhone;
            var is_iPhone4 = (bb == 320 && bh >= 372 && ratio == 'portrait' || bb == 480 && bh >= 212 && ratio == 'landscape') && is_iPhone;
            if (bb >= 1350 && bh >= 900 && ratio == 'landscape' || bb >= 675 && bh >= 900 && ratio == 'portrait')
                size = 'XL';
            else if (bb >= 960 && bh >= 640 && ratio == 'landscape' || bb >= 480 && bh >= 640 && ratio == 'portrait')
                size = 'L';
            else if (bb >= 720 && bh >= 480 && ratio == 'landscape' || bb >= 360 && bh >= 480 && ratio == 'portrait')
                size = 'M';
            else
                size = 'S';
            //OUTPUT:
            $this.removeClass('retina HD mobile desktop S M L XL landscape portrait square panorama iPad iPhone iPhone6p iPhone6 iPhone5 iPhone4');
            if (is_Retina)
                $this.addClass('retina');
            if (is_HD && !is_Retina)
                $this.addClass('HD');
            if (is_iPhone)
                $this.addClass('iPhone');
            if (is_iPad)
                $this.addClass('iPad');
            if (is_iPhone6p)
                $this.addClass('iPhone6p');
            if (is_iPhone6)
                $this.addClass('iPhone6');
            if (is_iPhone5)
                $this.addClass('iPhone5');
            if (is_iPhone4)
                $this.addClass('iPhone4');
            if (is_mobile)
                $this.addClass('mobile');
            else
                $this.addClass('desktop');
            $this.addClass(shape);
            $this.addClass(ratio);
            $this.addClass(size);
            if (init) {
                $(window).resize(function (event) {
                    $this.akbildschirm();
                    refreshcount++;
                });
            }
        });
    };
    //END AKBILDSCHIRM
    //FORMFUNCTIONS
    $.fn.akaddplaceholder = function (removelable, removerequired) {
        console.log('fn.akaddplaceholder() ->');
        this.find('input[type=text], input[type=password], textarea').each(function (index, el) {
            if (removerequired)
                $(this).prev('label').find('span.form-required').remove();
            $(this).attr('placeholder', $(this).prev('label').text());
            if (removelable)
                $(this).prev('label').hide();
        });
    };
    // $.fn.akwrapformitemsold = function(){ console.log('akwrapformitems() ->');
    //   //Item: inline inline gets wrapped; newline breaks
    //   this.find('.inline').each(function(){
    //     if ( $(this).parent().hasClass('inlinewrap') ) return;
    //     $(this).nextUntil("div:not(.inline), .newline").andSelf().wrapAll('<div class="inlinewrap" />');
    //   });
    // };
    $.fn.akwrapformitems = function (addclasses) {
        console.log('akwrapformitems() -> addclasses: ' + addclasses);
        addclasses = typeof addclasses !== 'undefined' ? addclasses + ' ' : '';
        this.each(function () {
            if ($(this).hasClass('akwrapformitems-wrapitem'))
                return;
            $(this).addClass('tmp-akwrapme akwrapformitems-wrapitem wrapitem ');
        });
        $('.tmp-akwrapme').each(function () {
            if ($(this).parent().hasClass('akwrapformitems-wrapped'))
                return;
            $(this).nextUntil('div:not(.tmp-akwrapme)').andSelf().wrapAll('<div class="' + addclasses + 'tmp-akwrapped akwrapformitems-wrapped wrapped" />');
        });
        $('.tmp-akwrapme').removeClass('tmp-akwrapme');
        $('.tmp-akwrapped').removeClass('tmp-akwrapped');
    };
    //END FORMFUNCTIONS
    //AKARM
    $.fn.akarm = function (closestSelector, excludeSel, excludeLinks) {
        console.log('akarm() ->');
        excludeLinks = typeof excludeLinks !== 'undefined' ? excludeLinks : true;
        this.each(function (index, el) {
            $that = $(this);
            $that.addClass('akarmed-master');
            $that.closest(closestSelector).addClass('akarmed-slave');
            $that.closest(closestSelector).css('cursor', 'pointer');
            if (typeof excludeSel !== 'undefined')
                $that.find(excludeSel).css('cursor', 'default');
            $that.closest(closestSelector).on('click', function (event) {
                console.log('akarm() -> .akarmed-master clicked');
                if ($(event.target).hasClass('akarmed-master'))
                    return true;
                if (excludeLinks)
                    if ($(event.target).is('a'))
                        return true;
                if (typeof excludeSel !== 'undefined')
                    if ($(event.target).is(excludeSel) || $(this).find(excludeSel).find(event.target).length) {
                        console.log('akarm() -> excludeSel clicked');
                        return true;
                    }
                ;
                event.preventDefault();
                //$that.trigger('click');
                $(this).find('.akarmed-master').trigger('click');
            });
        });
    };
    //Example: $('.example .usage a').akarm('.example', '.example .usage');
    //END AKARM
    //AKONEPAGENAV
    $.fn.akonepagenav = function (container_selector, page_selector, title_selector) {
        console.log('fn.akonepagenav() ->');
        //Usage: CONTAINER, PAGES, TITLE
        var $akopn_nav_parent = this;
        var $akopn_page_parent = $(container_selector);
        $akopn_page_parent.find(page_selector).each(function (index, el) {
            $akopn_nav_parent.append('<div class="AKonepagenav-bullet">' + $(this).find(title_selector).text() + '</div>');
        });
        $(window).scroll(function (event) {
            console.log(getspt());
            set_akopn_classes();
        });
        set_akopn_classes();
        function set_akopn_classes() {
            //TODO: USE global var spt!!!
            $akopn_page_parent.find(page_selector).each(function (index, el) {
                if ($(this).offset().top + $(this).height() < getspt()) {
                    $(this).addClass('scrolled-past');
                    $akopn_nav_parent.find('.AKonepagenav-bullet').eq($(this).index(page_selector)).addClass('scrolled-past');
                } else {
                    $(this).removeClass('scrolled-past');
                    $akopn_nav_parent.find('.AKonepagenav-bullet').eq($(this).index(page_selector)).removeClass('scrolled-past');
                }
                if ($(this).offset().top < getspt() + getbh() / 2) {
                    $(this).addClass('was-viewed');
                    $akopn_nav_parent.find('d.AKonepagenav-bullet').eq($(this).index(page_selector)).addClass('was-viewed');
                } else {
                    $(this).removeClass('was-viewed');
                    $akopn_nav_parent.find('.AKonepagenav-bullet').eq($(this).index(page_selector)).removeClass('was-viewed');
                }
            });
            $akopn_page_parent.find('.in-view').removeClass('in-view');
            $akopn_page_parent.find('.was-viewed:last').addClass('in-view');
            $akopn_nav_parent.find('.in-view').removeClass('in-view');
            $akopn_nav_parent.find('.was-viewed:last').addClass('in-view');
        }
    };
    //Example: $('#AKonepagenav:first').akonepagenav('.view-pageslide', 'article.node', '.field.title');
    //END AKONEPAGENAV
    //AKCLACULATEIMAGES
    $.fn.akCalculateImage = function (option, ignoreparents) {
        console.log('fn.akCalculateImage() ->');
        // clostetEL later?
        option = typeof option !== 'undefined' ? option : 'contain';
        ignoreparents = typeof ignoreparents !== 'undefined' ? ignoreparents : 0;
        var fill, stretch;
        if (option == 'stretch') {
            stretch = true;
        }
        if (option == 'fill') {
            stretch = true;
            fill = true;
        }
        this.each(function (index, el) {
            console.log('akCalculateImage() ->');
            $that = $(this);
            $that.addClass('akCalculateImage');
            $that.css('min-width', 'none').css('min-height', 'none').css('max-width', 'none').css('max-height', 'none').css('width', '').css('height', '');
            var $parent = $that.parents().eq(1);
            var parentWidth = $parent.width();
            var parentHeight = $parent.height();
            $parent.attr('data-akCalculateImage-width', parentWidth);
            $parent.attr('data-akCalculateImage-height', parentHeight);
            $that.attr('data-akCalculateImage-option', option).attr('data-akCalculateImage-ignoreparents', ignoreparents);
            var thisOriginalWidth = $that.attr('width');
            var thisOriginalHeight = $that.attr('height');
            if (!fill) {
                var factor = Math.min(parentWidth / thisOriginalWidth, parentHeight / thisOriginalHeight);
            } else {
                var factor = Math.max(parentWidth / thisOriginalWidth, parentHeight / thisOriginalHeight);
                stretch = true;
            }
            if (!stretch && factor > 1)
                factor = 1;
            $that.css('width', Math.ceil(factor * thisOriginalWidth) + 'px');
            $that.css('height', Math.ceil(factor * thisOriginalHeight) + 'px');
            //2ndrun
            if (fill)
                return;
            parentWidth = $parent.width();
            parentHeight = $parent.height();
            $parent.attr('data-akCalculateImage-width', parentWidth);
            $parent.attr('data-akCalculateImage-height', parentHeight);
            if (!fill) {
                var factor = Math.min(parentWidth / thisOriginalWidth, parentHeight / thisOriginalHeight);
            } else {
                var factor = Math.max(parentWidth / thisOriginalWidth, parentHeight / thisOriginalHeight);
                stretch = true;
            }
            if (!stretch && factor > 1)
                factor = 1;
            $that.css('width', Math.ceil(factor * thisOriginalWidth) + 'px');
            $that.css('height', Math.ceil(factor * thisOriginalHeight) + 'px');
        });
    };
    $(window).resize(function () {
        $('.akCalculateImage').each(function (index, el) {
            // if ( $(this).hasClass('akCalculateImage-fill') ) $(this).akCalculateImage('fill');
            // else if ( $(this).hasClass('akCalculateImage-stetch') ) $(this).akCalculateImage('stretch');
            $(this).akCalculateImage($(this).attr('data-akCalculateImage-option'), $(this).attr('data-akCalculateImage-ignoreparents'));
        });
    });
    //END AKCLACULATEIMAGES
    //AKOUTDATED
    function akoutdated(force) {
        console.log('akoutdated() -> force: ' + force);
        if ($('#akoutdated').length < 1)
            console.error('no #akoutdated');
        if (force)
            return false;
        $('#akoutdated').hide();
        if (Modernizr.flexbox && Modernizr.csstransforms)
            $('#akoutdated').remove();
        else
            $('#akoutdated').show();
    }
    ;
    //Remove Ajax-Container
    function removeajaxresult() {
        console.log('removeajaxresult()');
        $('#ajaxresult').remove();
    }
    //AKAUTOMENU
    var akautomenu_lastscrollpos = spt;
    var akautomenu_position;
    $.fn.akautomenu = function (init) {
        console.log('akautomenu() ->');
        init = typeof init !== 'undefined' ? init : 0;
        if ($('.akautomenu').length) {
            console.error('akautomenu() -> already called once');
            return false;
        }
        var $this = this;
        $this.addClass('akautomenu akautomenu-up').css('transform', 'translateY(' + spt + 'px)').css('-webkit-transform', 'translateY(' + spt + 'px)').css('-moz-transform', 'translateY(' + spt + 'px)').css('-ms-transform', 'translateY(' + spt + 'px)').css('-o-transform', 'translateY(' + spt + 'px)');
        akautomenu_position = spt;
        if (spt <= init)
            $this.addClass('akautomenu-init');
        else
            $this.removeClass('akautomenu-init');
        //$('.akautomenu').attr('data-akautomenu-lastscrollpos', spt)
        akautomenu_lastscrollpos = spt;
        $(window).scroll(function () {
            console.log('akautomenu() -> scroll ' + spt);
            var $this = $('.akautomenu:first');
            //var lastscrollpos = $this.attr('data-akautomenu-lastscrollpos')           --> akautomenu_lastscrollpos
            if (spt <= init)
                $this.addClass('akautomenu-init');
            else
                $this.removeClass('akautomenu-init');
            if (spt > akautomenu_lastscrollpos && !$this.hasClass('aksandwich-opened')) {
                $this.addClass('akautomenu-down').removeClass('akautomenu-up');
                if (spt > akautomenu_position + $this.outerHeight())
                    $this.addClass('akautomenu-away');
            } else if (spt < akautomenu_lastscrollpos || $this.hasClass('aksandwich-opened')) {
                $this.addClass('akautomenu-up').removeClass('akautomenu-down akautomenu-away');
                $this.css('transform', 'translateY(' + spt + 'px)').css('-webkit-transform', 'translateY(' + spt + 'px)').css('-moz-transform', 'translateY(' + spt + 'px)').css('-ms-transform', 'translateY(' + spt + 'px)').css('-o-transform', 'translateY(' + spt + 'px)');
                akautomenu_position = spt;
            }
            //$this.attr('data-akautomenu-lastscrollpos', spt)
            akautomenu_lastscrollpos = spt;
        });
    };
    //AKAUTOMENU
    // $.fn.akautomenu = function(init, threshold){ console.log('akautomenu() ->');
    //   init = typeof init !== 'undefined' ? init : 0;
    //   threshold = typeof threshold !== 'undefined' ? threshold : 50;
    //
    //   if ( $('.akautomenu').length ){ console.error('akautomenu() -> already called once'); return false; }
    //
    //   var $this = this
    //
    //   $this.addClass('akautomenu akautomenu-up').css('transform', 'translateY('+spt+'px)').css('-webkit-transform', 'translateY('+spt+'px)').css('-moz-transform', 'translateY('+spt+'px)').css('-ms-transform', 'translateY('+spt+'px)').css('-o-transform', 'translateY('+spt+'px)');
    //
    //   if ( spt <= init ) $this.addClass('akautomenu-init')
    //   else $this.removeClass('akautomenu-init')
    //
    //   $('.akautomenu').attr('data-akautomenu-lastscrollpos', spt)
    //
    //   $(window).scroll(function(){ console.log('akautomenu() -> scroll '+spt);
    //
    //     var $this = $('.akautomenu:first')
    //
    //     var lastscrollpos = $this.attr('data-akautomenu-lastscrollpos')
    //     var position = $this.attr('data-akautomenu-position')
    //
    //     if ( spt <= init ) $this.addClass('akautomenu-init')
    //     else $this.removeClass('akautomenu-init')
    //
    //     if ( spt > lastscrollpos && spt > position && !$this.hasClass('aksandwich-opened') ){
    //       $this.addClass('akautomenu-down').removeClass('akautomenu-up')
    //       $this.attr('data-akautomenu-lastscrollpos', spt)
    //     }
    //     else if ( spt <  (lastscrollpos-threshold) || spt <= position || $this.hasClass('aksandwich-opened') ){
    //       //var wasdown = $this.hasClass('akautomenu-down') ? true:false;
    //
    //       $this.addClass('akautomenu-up').removeClass('akautomenu-down')
    //       $this.css('transform', 'translateY('+spt+'px)').css('-webkit-transform', 'translateY('+spt+'px)').css('-moz-transform', 'translateY('+spt+'px)').css('-ms-transform', 'translateY('+spt+'px)').css('-o-transform', 'translateY('+spt+'px)');
    //       $this.attr('data-akautomenu-lastscrollpos', spt).attr('data-akautomenu-position', spt)
    //     }
    //
    //
    //   });
    // }
    //
    console.log('_adminmenu.js v2.7 ...');
    //ADMINMENU KEYBOARD LOGIN
    function adminmenu() {
        console.log('adminmenu() ->');
        $('#aklogin').akaddplaceholder(true, true);
        console.log('Adminmenu/Login hidden. Press CTRL+^ or CTRL+a to toggle.');
        $(document).on('keydown', function (e) {
            console.log(e.which);
            if (e.ctrlKey && (e.which == 27 || e.which == 65 || e.which == 192 || e.which == 160)) {
                if ($('input').is(':focus')) {
                    console.log('Admin prevented');
                    return false;
                }
                console.log('Hello Admin');
                if ($('body').hasClass('VIP')) {
                    if (e.shiftKey)
                        window.open(Drupal.settings.basePath + 'admin');
                    else
                        window.location.href = '#overlay=admin';
                } else if ($('#aklogin').length) {
                    $('#aklogin').slideToggle('fast');
                } else {
                    window.location.href = Drupal.settings.basePath + 'user/login';
                }
            }
            if (e.ctrlKey && (e.which == 67 && $('body').hasClass('VIP'))) {
                if ($('input').is(':focus')) {
                    console.log('Admin prevented');
                    return false;
                }
                console.log('Hello Admin');
                window.location.href = '#overlay=admin/config/development/performance';
            }
            if (e.ctrlKey && (e.which == 76 && $('body').hasClass('VIP'))) {
                if ($('input').is(':focus')) {
                    console.log('Admin prevented');
                    return false;
                }
                console.log('Hello Admin');
                window.location.href = Drupal.settings.basePath + 'user/logout';
            }
            if (e.ctrlKey && (e.which == 73 && $('body').hasClass('VIP'))) {
                if ($('input').is(':focus')) {
                    console.log('Admin prevented');
                    return false;
                }
                console.log('Hello Admin');
                window.location.href = '#overlay=admin/content';
            }
            if (e.ctrlKey && (e.which == 69 && $('body').hasClass('VIP'))) {
                if (e.shiftKey)
                    $('.akedit').remove();
                else
                    articleedit();
            }
        });
    }
    ;
    //ADMINMENU END
    //ARTICLE EDIT-ICON
    function articleedit() {
        console.log('articleedit() ->');
        if (!$('body').hasClass('VIP'))
            return;
        $('.akedit').remove();
        $('article.node[id^=node-]').each(function (index) {
            //if ( !$(this).attr('id') || ( $(this).attr('id').slice(0,5) != 'node-') ) return;
            var nodeurl = $(this).attr('id').replace('-', '/') + '/edit';
            $(this).append('<div class="akedit" style="position: absolute; bottom:0; left:0; z-index:9000; padding:.5em;"><a href="#overlay=' + nodeurl + '"><i class="zmdi zmdi-edit"></i></a></div>');
        });
    }
    ;
    //HIDE MESSAGES ON CLICK
    function hidemessages() {
        console.log('hidemessages() ->');
        $('div#messagescontainer').on('click', function () {
            $(this).fadeOut(200);
        });
    }
    ;
    console.log('_ajax v2.7 ...');
    $.fn.akajax = function (options, transitions) {
        console.log('akajax() ->');
        if (options == 'toggle') {
            animated = typeof animated !== 'undefined' ? transitions : false;
            akajaxToggle(this, transitions);
            return;
        }
        var option = $.extend({
            closestSelector: 'div',
            findSelector: false,
            resultSelector: '#ajaxresult',
            ajaxcontainer: 'hide',
            //'prepend'. 'append'
            toggle: true,
            //clearContainer should be false
            reloadIfExist: false,
            callbackIfExist: false,
            transitions: false,
            callback: function () {
                console.log('no callback');
            }
        }, options);
        this.each(function (index, el) {
            var $that = $(this);
            $that.addClass('akajax-armed');
            $that.on('click', function (event) {
                event.preventDefault();
                $sel = $(this).closest(option.closestSelector);
                if (option.findSelector != false)
                    $sel = $sel.find(option.findSelector);
                if ($sel.hasClass('akajax-loaded') && option.toggle == true) {
                    akajaxToggle($sel, options.transitions)    // if (options.transitions) $sel.find('div.akajax-box').slideToggle('fast');
                                                               // else $sel.find('div.akajax-box').toggle();
                                                               // $sel.toggleClass('akajax-closed');
;
                }
                if ($sel.hasClass('akajax-loaded') && option.reloadIfExist == false) {
                    console.log('.akajax already existed');
                    if (option.callbackIfExist) {
                        if (typeof option.callback == 'function') {
                            option.callback.call(this);
                        }
                    }
                    return false;
                }
                if (option.ajaxcontainer == 'hide')
                    $sel.css('min-height', $sel.height() + 'px');
                $sel.find('.akajax-box').remove();
                $sel.addClass('akajax').addClass('akajax-loading');
                if (option.ajaxcontainer == 'hide') {
                    $sel.children().addClass('akajax-hidden').hide();
                    $sel.append('<div class="akajax-box"></div>').show();
                } else if (option.ajaxcontainer == 'clear')
                    $sel.html('<div class="akajax-box"></div>');
                else if (option.ajaxcontainer == 'prepend')
                    $sel.prepend('<div class="akajax-box"></div>');
                else if (option.ajaxcontainer == 'append')
                    $sel.append('<div class="akajax-box"></div>');
                if (options.transitions)
                    $sel.find('div.akajax-box').hide();
                $sel.find('div.akajax-box').load($that.attr('href') + ' ' + option.resultSelector, function (response, status, xhr) {
                    $sel.removeClass('akajax-loading').removeClass('akajax-error');
                    if (status == 'error') {
                        console.error('Error' + xhr.status + ' ' + xhr.statusText);
                        $sel.addClass('akajax-error');
                    } else {
                        $sel.addClass('akajax-loaded');
                    }
                    if (typeof option.callback == 'function') {
                        option.callback.call(this);
                    }
                    if (options.transitions)
                        $sel.find('div.akajax-box').slideDown('fast');
                });
            });
        });
        function akajaxToggle($sel, transitions) {
            console.log('akajaxToggle() ->');
            //transitions: full, half
            if (!$sel.hasClass('akajax')) {
                console.error('This is not (yet) an .akajax');
                return;
            }
            if (!$sel.hasClass('akajax-loaded')) {
                console.error('This .akajax is not (yet) loaded');
                return;
            }
            transitions = typeof transitions !== 'undefined' ? transitions : false;
            if (transitions == 'full') {
                $sel.find('.akajax-hidden').slideToggle('fast');
                $sel.find('div.akajax-box').slideToggle('fast');
            } else if (transitions == 'half') {
                $sel.find('.akajax-hidden').toggle();
                $sel.find('div.akajax-box').slideToggle('fast');
            } else {
                $sel.find('.akajax-hidden').toggle();
                $sel.find('div.akajax-box').toggle();
            }
            $sel.toggleClass('akajax-closed');
        }
    };
    //END
    console.log('_jplayer.js 1.5 ...');
    $.fn.akjplayerA = function () {
        this.each(function (jplayerindex) {
            console.log('akjplayerA() ->');
            $(this).addClass('akjplayerA akjplayerA_' + jplayerindex);
            $(this).append('<div class="jp-container"></div>');
            $(this).append('<div class="jp-controls"></div>');
            $(this).find('div.jp-controls').append('<div class="jp-play"></div><div class="jp-pause"></div><div class="jp-secondary"><div class="jp-progress"><div class="jp-seek-bar"><div class="jp-play-bar"></div></div></div><div class="jp-current-time"></div></div>');
            $(this).find('div.jp-container').jPlayer({
                ready: function () {
                    $(this).jPlayer('setMedia', { mp3: $(this).closest('.akjplayerA').attr('data-audio') });
                },
                cssSelectorAncestor: '.akjplayerA_' + jplayerindex + ' .jp-controls',
                swfPath: '.',
                supplied: 'mp3',
                play: function (e) {
                    console.log('jPlayer() -> play');
                    $(this).jPlayer('pauseOthers');
                },
                timeupdate: function (e) {
                    console.log('jPlayer() -> timeupdate');
                },
                seeking: function (e) {
                    console.log('jPlayer() -> seeking');
                    $(this).closest('div.akjplayerA').find('.jp-controls').addClass('jp-buffering');
                },
                seeked: function (e) {
                    console.log('jPlayer() -> seeked');
                    $(this).closest('div.akjplayerA').find('.jp-controls').removeClass('jp-buffering');
                }
            });
        });    // $(document).on('click', 'div.akjplayer div.jp-seek-bar', function(event) { console.log('.jp-seek-bar <- click');
               //   event.preventDefault();
               //   var ct = $(this).closest('div.akjplayer').find('div.jp-container').data("jPlayer").status.currentTime;
               //   var sp = $(this).closest('div.akjplayer').find('div.jp-container').data('jPlayer').status.seekPercent;
               // });
    };
    //$('div.akjplayerA').akjplayerA();
    $.fn.akjplayerV = function () {
        this.each(function (jplayerindex) {
            console.log('akjplayerV() ->');
            $(this).addClass('akjplayerV akjplayerV_' + jplayerindex);
            $(this).append('<div class="jp-container"></div>');
            $(this).append('<div class="jp-video-play"></div>');
            $(this).append('<div class="jp-controls"></div>');
            //$(this).find('div.jp-video-play').append('<button class="jp-video-play-icon" role="button" tabindex="0">play</button>');
            $(this).find('div.jp-controls').append('<div class="jp-play"></div><div class="jp-pause"></div><div class="jp-secondary"><div class="jp-progress"><div class="jp-seek-bar"><div class="jp-play-bar"></div></div></div><div class="jp-current-time"></div></div>');
            $(this).find('div.jp-container').jPlayer({
                ready: function () {
                    $(this).jPlayer('setMedia', { m4v: $(this).closest('.akjplayerV').attr('data-video') });
                },
                cssSelectorAncestor: '.akjplayerV_' + jplayerindex + ' .jp-controls',
                swfPath: '.',
                supplied: 'm4v',
                play: function (e) {
                    console.log('jPlayer() -> play');
                    $(this).jPlayer('pauseOthers');
                },
                timeupdate: function (e) {
                    console.log('jPlayer() -> timeupdate');
                },
                seeking: function (e) {
                    console.log('jPlayer() -> seeking');
                    $(this).closest('div.akjplayerV').find('.jp-controls').addClass('jp-buffering');
                },
                seeked: function (e) {
                    console.log('jPlayer() -> seeked');
                    $(this).closest('div.akjplayerV').find('.jp-controls').removeClass('jp-buffering');
                }
            });
        });    // $(document).on('click', 'div.akjplayer div.jp-seek-bar', function(event) { console.log('.jp-seek-bar <- click');
               //   event.preventDefault();
               //   var ct = $(this).closest('div.akjplayer').find('div.jp-container').data("jPlayer").status.currentTime;
               //   var sp = $(this).closest('div.akjplayer').find('div.jp-container').data('jPlayer').status.seekPercent;
               // });
    };
    //$('div.akjplayerV').akjplayerV();
    console.log('_aksandwich.js v2.7.1 ...');
    $.fn.aksandwich = function (button) {
        console.log('aksandwich() ->');
        if (button == 'up' || button == 'down' || button == 'toggle') {
            if ($('.aksandwich').length)
                $sandwich = $('.aksandwich');
            $button = $('.aksandwich-button');
            if (button == 'up') {
                $sandwich.slideUp(200);
                $('.aksandwich-indicator').addClass('aksandwich-hidden').removeClass('aksandwich-opened');
            } else if (button == 'down') {
                $sandwich.slideDown(200);
                $('.aksandwich-indicator').removeClass('aksandwich-hidden').addClass('aksandwich-opened');
            } else if (button == 'toggle') {
                $sandwich.slideToggle(200);
                $('.aksandwich-indicator').toggleClass('aksandwich-hidden').toggleClass('aksandwich-opened');
            } else {
                console.log('no sandwich to up/down');
                return false;
            }
            ;
            return;
        }
        $button = $(button).addClass('aksandwich-button aksandwich-indicator');
        this.each(function (index) {
            $sandwich = $(this);
            $sandwich.addClass('aksandwich aksandwich' + index + ' aksandwich-indicator').hide();
            if (!$sandwich.is(':visible')) {
                $('.aksandwich-indicator').addClass('aksandwich-hidden').removeClass('aksandwich-opened');
            }
        });
        // Swipe-Support
        $('.aksandwich-button, .aksandwich').swipe({
            tap: function (event, target) {
                console.log('aksandwich() -> tap/click ' + $(event.target).attr('class'));
                if (!$(target).closest('.aksandwich-button').length)
                    return false;
                $('.aksandwich').aksandwich('toggle');
            },
            swipe: function (event, direction, distance, duration, fingerCount) {
                console.log('aksandwich() -> swipe ' + direction + ' ' + $(event.target).attr('class'));
                if (direction == 'up') {
                    $('.aksandwich').aksandwich('up');
                } else if (direction == 'down') {
                    $('.aksandwich').aksandwich('down');
                }
            },
            // swipeStatus:function(event, phase, direction, distance, duration, fingers, fingerData) { console.log('aksandwich() -> swipeStatus '+direction+' '+$(event.target).attr('class'));
            //   console.log(distance);
            //   // if (direction == 'down'){
            //   //   $('.aksandwich').css('height', distance+10+'px');
            //   // }
            // },
            threshold: 5
        });
    };
    // Example Init: $('.sandwich').aksandwich('.sandwich-button');
    // Example Event: $('.sandwich').aksandwich('down');
    console.log('_akswiper.js v2.7 ...');
    //VIEWSWIPER
    $.fn.akViewSwiper = function () {
        console.log('akViewSwiper() ->');
        this.each(function (index, el) {
            var $that = $(this);
            $that.addClass('akviewswiper').addClass('akviewswiper' + index);
            $that.find('.swiper-container:first>.swiper-wrapper').find('>.swiper-slide').each(function (index, el) {
                //$(this).attr('data-hash', $(this).find('.field.title:first').text().replace(/\W+/g, '') );
                if ($(this).find('>article.node').attr('about')) {
                    hash = $(this).find('>article.node').attr('about').split('/').pop();
                    $(this).attr('data-hash', hash);
                    console.log('akviewswiper() -> #hash is ' + hash);
                } else
                    console.log('akviewswiper() -> no #hash here');
            });
            $that.find('>.swiper-container').swiper({
                direction: 'horizontal',
                slidesPerView: 1,
                loop: false,
                hashnav: true,
                shortSwipes: false,
                touchAngle: 20    // nextButton: $that.find('.swiper-button-next'),
                      // prevButton: $that.find('.swiper-button-prev'),
                      // pagination: $that.find('.view-swiper-pagination'),
                      // paginationClickable: true,
                      // paginationBulletRender: function (index, className) {
                      //   return '<span class="' + className + '">' + $that.find('>.swiper-container>.swiper-wrapper>.swiper-slide').eq(index).find('.field.title:first').text() +'</span>';
                      // }
            });
            // $that.find('>.swiper-container')[0].swiper.on('onSlideChangeStart', function(swiper){
            //   swiper.disableMousewheelControl();
            //   setTimeout(function(){
            //     swiper.enableMousewheelControl()
            //   }, 1500);
            // });
            var thisSwiper = $that.find('>.swiper-container')[0].swiper;
            // $('article#node-9').on('click', function(event) {
            //   event.preventDefault();
            //   thisSwiper.slideTo( 1 );
            // });
            // thisSwiper.on('onSlideChangeStart', function(swiper) {
            //   akViewSwiper_onSlideChangeStart(swiper);
            // });
            thisSwiper.on('onInit', function (swiper) {
                akViewSwiper_onInit(swiper);
            });
            thisSwiper.on('onSlideChangeStart', function (swiper) {
                akViewSwiper_onSlideChangeStart(swiper);
            });
            thisSwiper.on('onSlideChangeEnd', function (swiper) {
                akViewSwiper_onSlideChangeEnd(swiper);
            });    // function hidetitle(){
                   //   clearInterval(hidetitleTimeout);
                   //   $('article.node-image-section-like .field.title').hide();
                   //   $('.swiper-slide-active article.node-image-section-like .field.title').fadeIn(500);
                   //
                   //   hidetitleTimeout = setTimeout(function () {
                   //     $('article.node-image-section-like .field.title').fadeOut(2000);
                   //   }, 1000);
                   // }; hidetitle();
        });    //each
    };
    //IMAGESWIPER
    $.fn.akImageSwiper = function () {
        console.log('akimageswiper() ->');
        this.each(function (index, el) {
            var $that = $(this);
            $that.addClass('akimageswiper').addClass('akimageswiper' + index);
            $that.find('.swiper-slide img').akCalculateImage('stretch', 1);
            if ($that.find('.swiper-slide').length < 2) {
                console.log('only one img here \u2013\xA0nothing to swipe');
                $that.addClass('only-one-slide');
                $that.find('.swiper-slide').addClass('only-swiper-slide');
                $that.closest('.akimageswiper').find('.swiper-button').remove();
                return;
            }
            $that.find('.swiper-container').swiper({
                direction: 'horizontal',
                slidesPerView: 'auto',
                centeredSlides: true,
                //freeMode: true,
                shortSwipes: true,
                touchAngle: 20,
                grabCursor: true,
                mousewheelControl: false,
                mousewheelSensitivity: 1,
                nextButton: $that.find('.swiper-button-next'),
                prevButton: $that.find('.swiper-button-prev')
            });
            var thisSwiper = $that.find('.swiper-container')[0].swiper;
            thisSwiper.on('click', function (swiper) {
                console.log('$thisSwiper on click -> ' + thisSwiper.clickedIndex);
                if (typeof thisSwiper.clickedIndex !== 'undefined') {
                    thisSwiper.slideTo(thisSwiper.clickedIndex);
                }
            });
        });    //each
    };
    //IMAGEFADER
    $.fn.akImageFader = function (time, closesestelement) {
        console.log('akimagefader() ->');
        excludeLinks = typeof closesestelement !== 'undefined' ? closesestelement : false;
        this.each(function (index, el) {
            var $that = $(this);
            $that.addClass('akimagefader').addClass('akimagefader' + index);
            $that.find('.fader-slide').find('img').akCalculateImage('fill');
            var $active, $next, $prev;
            $that.find('.fader-slide:first').addClass('akimagefader-active');
            setClasses();
            function toNext() {
                if (closesestelement != false)
                    if ($that.closest(closesestelement).length == 0)
                        return;
                console.log('akimagefader() -> toNext');
                setClasses();
                setTimeout(function () {
                    //if ( !$that.find('.akimagefader-prev') ) return false;
                    $next.addClass('akimagefader-active').removeClass('akimagefader-next');
                    $active.addClass('akimagefader-prev').removeClass('akimagefader-active');
                    $prev.removeClass('akimagefader-prev');
                }, 1000);
            }
            function setClasses() {
                $active = $that.find('.fader-slide.akimagefader-active');
                $next = $active.next('.fader-slide').length ? $active.next('.fader-slide') : $that.find('.fader-slide:first');
                $next.addClass('akimagefader-next');
                $prev = $active.prev('.fader-slide').length ? $active.prev('.fader-slide') : $that.find('.fader-slide:last');
                $prev.addClass('akimagefader-prev');
            }
            // $that.on('click', function(event) {
            //   event.preventDefault();
            //   toNext();
            // });
            var animated = setInterval(function () {
                toNext();
            }, time);
        });
    };
    //$('.field-name-field-images-fader').akImageFader(4000, '.swiper-slide-active');
    console.log('_boilerplate.js v2.7 ...');
    /*eslint-disable */
    function boilerplate() {
        // Avoid `console` errors in browsers that lack a console.
        var method;
        var noop = function () {
        };
        var methods = [
            'assert',
            'clear',
            'count',
            'debug',
            'dir',
            'dirxml',
            'error',
            'exception',
            'group',
            'groupCollapsed',
            'groupEnd',
            'info',
            'log',
            'markTimeline',
            'profile',
            'profileEnd',
            'table',
            'time',
            'timeEnd',
            'timeline',
            'timelineEnd',
            'timeStamp',
            'trace',
            'warn'
        ];
        var length = methods.length;
        var console = window.console = window.console || {};
        while (length--) {
            method = methods[length];
            // Only stub undefined methods.
            if (!console[method]) {
                console[method] = noop;
            }
        }
        //RequestAnimationFrame Crossbrowser
        if (!window.requestAnimationFrame) {
            window.requestAnimationFrame = function () {
                return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback, element) {
                    window.setTimeout(callback, 1000 / 60);
                };
            }();
        }
    }
    ;
    /*eslint-enable */
    console.log('_events.js ...');
    function buttons() {
        $(document).on('click', 'body.front .abutton.home', function (event) {
            console.log('body.front .abutton.home <- don click');
            event.preventDefault();
            $('html, body').animate({ scrollTop: 0 }, 250);
            $('.akviewswiper0 .swiper-container')[0].swiper.slideTo(0);
        });
        $(document).on('click', 'body.front .abutton.reframe-bottom', function (event) {
            console.log('.swiper-button-up <- don click');
            event.preventDefault();
            $('html, body').animate({ scrollTop: $('.node-main-section .field-name-field-navfields').offset().top }, 250);
        });
        $(document).on('click', 'body.front .field-name-field-navfields a', function (event) {
            console.log('.field-name-field-navfields a <- don click');
            event.preventDefault();
            $('html, body').animate({ scrollTop: $('.ajax').offset().top }, 250);
        });
        $(document).on('click', 'body.front .abutton.profil', function (event) {
            console.log('body.front .abutton.profil <- don click');
            event.preventDefault();
            $('html, body').animate({ scrollTop: 0 }, 250);
            //$('.akviewswiper0 .swiper-container')[0].swiper.slideTo(2);
            $('.akviewswiper0 .swiper-container')[0].swiper.slideTo(2);
        });
        $(document).on('click', 'body.front .abutton.reframe', function (event) {
            console.log('body.front .abutton.reframe <- don click');
            event.preventDefault();
            $('.akjplayerV .jp-container').jPlayer('pause');
            $('html, body').animate({ scrollTop: $('.node-main-section').offset().top }, 250);
        });
        $(document).on('click', 'body.front .abutton.contact', function (event) {
            console.log('body.front .abutton.contact <- don click');
            event.preventDefault();
            $('html, body').animate({ scrollTop: 0 }, 250);
            $('.akviewswiper0 .swiper-container')[0].swiper.slideTo($('.akviewswiper0 .swiper-slide').length - 1);
        });
        $(document).on('click', 'body.front .abutton.partner', function (event) {
            console.log('body.front .abutton.partner <- don click');
            event.preventDefault();
            $('html, body').animate({ scrollTop: 0 }, 250);
            $('.akviewswiper0 .swiper-container')[0].swiper.slideTo(4);
        });
        $(document).on('click', 'body.front .abutton.vortraege', function (event) {
            console.log('body.front .abutton.vortraege <- don click');
            event.preventDefault();
            $('html, body').animate({ scrollTop: 0 }, 250);
            $('.akviewswiper0 .swiper-container')[0].swiper.slideTo($('.akviewswiper0 .swiper-slide').length - 2);
        });
        if (!$('.view-swiper').find('#node-24').length)
            $('.abutton.vortraege').closest('li').remove();
        $(document).on('click', '.swiper-button-next', function (event) {
            console.log('.swiper-button-next <- don click');
            event.preventDefault();
            var swiper = $(this).closest('.swiper-container').get(0).swiper;
            setTimeout(function () {
                swiper.slideTo(swiper.activeIndex + 1);
            }, 10);
        });
        $(document).on('click', '.swiper-button-prev', function (event) {
            console.log('.swiper-button-prev <- don click');
            event.preventDefault();
            var swiper = $(this).closest('.swiper-container').get(0).swiper;
            setTimeout(function () {
                swiper.slideTo(swiper.activeIndex - 1);
            }, 10);
        });
        $(document).on('click', '#node-15 .close a', function (event) {
            console.log('.swiper-button-prev <- don click');
            event.preventDefault();
            $(this).closest('.item').hide();
        });
        $(document).on('click', '#node-15 .more', function (event) {
            console.log('.swiper-button-prev <- don click');
            event.preventDefault();
            $(this).closest('.item').next('.item').show();
        });
    }
    console.log('_main.js ...');
    //$('.AKonepagenav:first').akonepagenav('div.view-pageslide', 'article.node', 'div.field.title');
    console.log('init.js v2.7 ...');
    (function init() {
        console.log('init() ->');
        //INITFUNCTIONS
        //Start with a boilerplate
        boilerplate();
        //Show notice for outdated browsers
        //akoutdated(true);
        //Set body classes
        $('body').akbildschirm(true);
        //Adminmenu Functions
        adminmenu();
        //Set keyboard shortcuts
        hidemessages();
        //Set keyboard shortcuts
        //Process Forms
        $('.webform-container-inline').akwrapformitems('.form-item');
        //?
        //Ajax
        $('.field-name-field-navfields a').akajax({
            closestSelector: '#container',
            findSelector: '.ajax',
            resultSelector: '#ajaxresult>article.node',
            transitions: true,
            ajaxcontainer: 'append',
            toggle: false,
            callbackIfExist: true,
            reloadIfExist: true,
            callback: function () {
                $('html, body').animate({ scrollTop: $('.ajax').offset().top }, 250);
            }
        });
        //$('.view-events a, .view-events-kids a').akarm('article.node');
        //BASIC
        //Init Sandwich-Button
        $('.sandwich').aksandwich('.sandwich-button');
        //Init jPlayers
        //$('.akjplayerA').akjplayerA();
        $('.akjplayerV').akjplayerV();
        //Init Swipers
        $('.view-swiper').akViewSwiper();
        //$('.field-name-field-images-swiper').akImageSwiper();
        //EXTRA
        $('#node-10 .jp-controls').remove();
        $('#node-10 .jp-container').bind($.jPlayer.event.ended, function (event) {
            $(this).jPlayer('play');
        });
        $('.swiper-slide-active .akjplayerV .jp-container').bind($.jPlayer.event.ready, function (event) {
            $(this).jPlayer('play');
        });
        //EVENTS
        buttons();
        $('header').akautomenu(100);
        //Remove Ajax
        removeajaxresult();    //Start Beatmaker
                               //beatmaker();
    }());
    //CALLBACKS
    //Swipers
    // function akViewSwiper_onInit(swiper){  console.log('akViewSwiper_onInit('+swiper.activeIndex+')')
    //   countslides(swiper);
    // }
    function akViewSwiper_onSlideChangeStart(swiper) {
        console.log('akViewSwiper_onSlideChangeStart(' + swiper.activeIndex + ')');
        $('.akjplayerV .jp-container').jPlayer('pause');
        countslides(swiper);
    }
    function akViewSwiper_onSlideChangeEnd(swiper) {
        console.log('akViewSwiper_onSlideChangeStart(' + swiper.activeIndex + ')');
        $('.swiper-slide-active .akjplayerV .jp-container').jPlayer('play');
        swiper.update(true);
    }
    function countslides(swiper) {
        $(swiper.container[0]).removeClass(function (index, css) {
            return (css.match(/(^|\s)swiper-index-\S+/g) || []).join(' ');
        }).addClass('swiper-index-' + swiper.activeIndex);
        if (!$(swiper.container[0]).find('.swiper-slide-next').length)
            $(swiper.container[0]).addClass('swiper-index-last');
    }
    countslides($('.akviewswiper>.swiper-container')[0].swiper);
    //init
    //BEATMAKER
    function beatmaker() {
        window.setTimeout(beatmaker, 1000 / 10);
        //EVENTS
        console.log('tick');
    }
});